import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from "recharts";
import { fmtEUR } from "../lib/format";

const MONTH_NAMES = ["Gen", "Feb", "Mar", "Apr", "Mag", "Giu", "Lug", "Ago", "Set", "Ott", "Nov", "Dic"];

export default function TimelineChart() {
  const [data, setData] = useState([]);

  useEffect(() => {
    api.get("/dashboard/monthly", { params: { months: 6 } }).then((r) => {
      setData(r.data.map((d) => {
        const [y, m] = d.month.split("-");
        return { ...d, label: `${MONTH_NAMES[parseInt(m) - 1]} '${y.slice(-2)}` };
      }));
    });
  }, []);

  return (
    <div className="border border-neutral-200 bg-white p-6" data-testid="timeline-chart">
      <div className="flex items-start justify-between mb-4">
        <div>
          <div className="mono-label">Cash Flow</div>
          <h2 className="font-display text-xl font-medium mt-1">Timeline economica · 6 mesi</h2>
        </div>
        <div className="flex items-center gap-3 text-xs">
          <div className="flex items-center gap-1.5"><div className="h-2.5 w-2.5" style={{ background: "#9CA3AF" }} /> Maturato</div>
          <div className="flex items-center gap-1.5"><div className="h-2.5 w-2.5" style={{ background: "#3B82F6" }} /> Fatturato</div>
          <div className="flex items-center gap-1.5"><div className="h-2.5 w-2.5" style={{ background: "var(--brand-primary)" }} /> Pagato</div>
        </div>
      </div>
      <div className="h-64">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} margin={{ top: 5, right: 10, left: 0, bottom: 5 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
            <XAxis dataKey="label" tick={{ fontSize: 11, fontFamily: "JetBrains Mono", fill: "#6b7280" }} tickLine={false} axisLine={{ stroke: "#e5e5e5" }} />
            <YAxis tick={{ fontSize: 11, fontFamily: "JetBrains Mono", fill: "#6b7280" }} tickLine={false} axisLine={{ stroke: "#e5e5e5" }} tickFormatter={(v) => `${(v / 1000).toFixed(0)}k`} />
            <Tooltip
              contentStyle={{ border: "1px solid #e5e5e5", borderRadius: 2, fontSize: 12, fontFamily: "IBM Plex Sans" }}
              formatter={(v) => fmtEUR(v)}
              labelStyle={{ fontFamily: "JetBrains Mono", fontSize: 11, textTransform: "uppercase" }}
            />
            <Bar dataKey="accrued" fill="#9CA3AF" name="Maturato" />
            <Bar dataKey="invoiced" fill="#3B82F6" name="Fatturato" />
            <Bar dataKey="paid" fill="var(--brand-primary)" name="Pagato" />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
